export const IMPORT_WORKSPACE_WORKFLOW_SKILL_NAME =
  "import_workspace_workflow_skill";

export const IMPORT_WORKSPACE_WORKFLOW_SKILL_DESC = `Imports pasted SKILL.md content into a DRAFT workspace skill.

Inputs:
- organizationId (optional): The server binds this to the active authorized chat workspace.
- markdown (required): The markdown content to import.

Use this when a user pastes an existing SKILL.md and wants it normalized for review. This creates a DRAFT only.`;
